module.exports = __webpack_public_path__ + "static/AddFireConfig-bf530d3a8ae8787e5aca31d486540e80.png";